/** Shared localized legalisation overview, without invented credentials or service promises. */
import { LGZ_LOCALE_UI } from "./locale-ui";
export type LgzLocale = "en" | "zh" | "ja" | "ko" | "vi" | "id";

export interface LgzLocaleCopy {
  hreflang: string;
  title: string;
  description: string;
  h1: string;
  lead: string;
  benefits: Array<[string, string]>;
  faqs: Array<{ q: string; a: string }>;
  ctaCall: string;
  ctaLine: string;
  breadcrumbHome: string;
  breadcrumbLgz: string;
  seeAllServices: string;
  seeAllCountries: string;
  sections: Array<{ heading: string; paragraphs: string[] }>;
}


function overview(locale: LgzLocale): LgzLocaleCopy {
  const u = LGZ_LOCALE_UI[locale];
  return {
    hreflang: locale,
    title: `${u.hub} — ${u.suffix} | Thai Notary Law`,
    description: `${u.lead} ${u.cta}`,
    h1: `${u.hub} — Thai Notary Law`,
    lead: u.lead,
    benefits: [[u.docsTitle, u.documents], [u.feesTitle, u.fees]],
    faqs: [{ q: u.acceptQ, a: u.acceptA }, { q: u.presenceQ, a: u.presenceA }],
    ctaCall: u.cta, ctaLine: u.check,
    breadcrumbHome: u.home, breadcrumbLgz: u.hub,
    seeAllServices: u.actionTitle, seeAllCountries: u.countryPrefix,
    sections: [
      { heading: u.routeTitle, paragraphs: [u.route, u.future, u.nonMember] },
      { heading: u.checkTitle, paragraphs: [u.check] },
      { heading: u.boundaryTitle, paragraphs: [u.boundary] },
    ],
  };
}
export const LGZ_LOCALE_COPY: Record<LgzLocale, LgzLocaleCopy> = {
  en: overview("en"), zh: overview("zh"), ja: overview("ja"),
  ko: overview("ko"), vi: overview("vi"), id: overview("id"),
};
